export const deleteTenantConfirmationValidation = (confirmation: string, original:string) => {
  if (confirmation !== original) {
    return "does not match";
  }

  return null;
};
